import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { SquidexService } from '../../../../services/squidex.service'
import { SquidexCacheService } from '../../../../services/squidex-cache.service'
import { Observable, of, tap } from 'rxjs'
import { isScullyGenerated, TransferStateService } from '@scullyio/ng-lib'
@Component({
  selector: 'flowaccount-member-each-region',
  templateUrl: './member-each-region.component.html',
  styleUrls: ['./member-each-region.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MemberEachRegionComponent implements OnInit {
  public regions = [
    {
      key: 'central',
      label: 'C',
      image: 'central_region',
    },
    { key: 'north', label: 'N', image: 'northern_region' },
    { key: 'northeastern', label: 'NE', image: 'northeastern_region' },
    { key: 'south', label: 'S', image: 'southern_region' },
  ]
  public serviceList$: Observable<object[]>
  private readonly _cacheKey = 'NUMBER_OF_ACCOUNTING_FIRM_KEY'
  private readonly _squidexContentKey = 'number-of-accounting-firm'

  constructor(
    public translate: TranslateService,
    public squidexService: SquidexService,
    private squidexCacheService: SquidexCacheService,
    private transferState: TransferStateService,
  ) {}

  ngOnInit(): void {
    if (isScullyGenerated()) {
      this.serviceList$ = this.transferState.useScullyTransferState<object[]>(this._cacheKey, of([]))
    } else {
      this.serviceList$ = this.squidexCacheService
        .getServiceList$(
          this._cacheKey,
          this._squidexContentKey,
          this.squidexService.getContentSquidexApi.bind(this.squidexService),
        )
        .pipe(
          tap((data) => {
            this.transferState.setState(this._cacheKey, data)
          }),
        )
    }
  }
}
